import { createSlice } from "@reduxjs/toolkit";

export const BULK_UPLOAD_VIEWS = {
  ITEM_CONDITION: "itemCondition",
  SHOW_SCOPE_DELIVERY: "showScopeDelivery",
  EBAY_CONDITION_TEXT: "ebayConditionText",
  UPLOAD_FILE: "uploadFile",
};
// Initial state
export const bulkUploadNavigationInitialState = {
  bulkUploadNavigationItems: [
    { id: BULK_UPLOAD_VIEWS.ITEM_CONDITION, labelKey: "itemCondition" },
  ],
  bulkUploadCurrentView: BULK_UPLOAD_VIEWS.ITEM_CONDITION,
};

// Slice
const bulkUploadSlice = createSlice({
  name: "bulkUploadNavigation",
  initialState: bulkUploadNavigationInitialState,
  reducers: {
    // Set bulk upload navigation items
    setBulkUploadNavigationItems: (state, action) => {
      state.bulkUploadNavigationItems = action.payload;
    },

    // Set bulk upload current view
    setBulkUploadCurrentView: (state, action) => {
      state.bulkUploadCurrentView = action.payload;
    },

    // Reset all state
    resetBulkUploadNavigationSlice: () => bulkUploadNavigationInitialState,
  },
});

// Export actions
export const {
  setBulkUploadNavigationItems,
  setBulkUploadCurrentView,
  resetBulkUploadNavigationSlice,
} = bulkUploadSlice.actions;

// Export selectors
export const selectBulkUploadNavigationItems = (state) =>
  state.bulkUploadNavigation?.bulkUploadNavigationItems;

export const selectBulkUploadCurrentView = (state) =>
  state.bulkUploadNavigation?.bulkUploadCurrentView;

// Export reducer
export default bulkUploadSlice.reducer;
